//  Node imports
import {
  Bitmap,
  Container,
  IEvent,
  IGraphics,
  ITween,
  Linear,
  MeterBitmap,
  SpineBase,
  delayedCall,
  dispatcher,
  ingenuity,
  killDelayedCall,
} from "@quest/base-core";
import { Model as platformModel } from "@quest/platform-murka/dist";
import {
  FreeGameController,
  SlotConstantsBehavior,
  SoundConstant,
  FreeGameViewBehavior,
  FreeGameModelBehavior,
  SlotEventConstantsBehavior,
} from "@quest/murka-games-behavior-leopard/dist";
import { IObject } from "@quest/adapter-interface";
import { constants } from "@quest/base-core/dist/detectDeviceEnvironment/Constants";
import { BitmapImage, Emitter } from "@quest/pixi-bridge";
import { SlotEventConstants } from "@quest/slot-core/dist/SlotConstants/SlotEventDispatchers";

//  Class imports
import { GameParserModel } from "../Platform/GameParserModel";
import { eventDispatchers } from "../Constants/EventDispatchers";
import { SoundConstantGame } from "../Constants/SoundConstantGame";
import { gameConstants } from "../Constants/gameConstants";

export class FreeGameControllerGame extends FreeGameController {
  private grandJackpotMeter: MeterBitmap;
  private majorJackpotMeter: MeterBitmap;
  private minorJackpotMeter: MeterBitmap;
  private miniJackpotMeter: MeterBitmap;
  // private freegameBgSpine: SpineBase;
  private jackpotPanelContainer: Container;
  //private freegameBgSpineContainer: Container;
  private jackpotPanelGrandContainer: Container;
  private jackpotPanelMajorContainer: Container;
  private jackpotPanelMinorContainer: Container;
  private jackpotPanelMiniContainer: Container;
  private particleContainer: Container;
  private grandJackpotCounter: number = 0;
  private majorJackpotCounter: number = 0;
  private minorJackpotCounter: number = 0;
  private miniJackpotCounter: number = 0;
  private grandJackpotNumber: MeterBitmap;
  private majorJackpotNumber: MeterBitmap;
  private minorJackpotNumber: MeterBitmap;
  private miniJackpotnumber: MeterBitmap;
  private counterEffectContainer: Container;
  private sortedJackpot: [string, number][];
  private jackpotAlpha: IGraphics;
  private smoke: Bitmap;
  private smokeSprite: BitmapImage;
  private particle_mini: number = 3;
  private particle_minor: number = 2;
  private particle_major: number = 1;
  private particle_grand: number = 0;
  private reelBGSpine: SpineBase;

  private particleData: any = {
    emitterType: 0,
    id: "coinEmitter_1",
    autoStart: false,
    image: "White_bubble",
  };

  private particleConfig: any = {
    alpha: {
      start: 1,
      end: 0,
    },
    scale: {
      start: 1.2,
      end: 0.3,
      minimumScaleMultiplier: 1,
    },
    color: {
      start: "#ffffff",
      end: "#ffffff",
    },
    speed: {
      start: 50,
      end: 200,
      minimumSpeedMultiplier: 1,
    },
    acceleration: {
      x: 0,
      y: 50,
    },
    maxSpeed: 0,
    startRotation: {
      min: 0,
      max: 360,
    },
    noRotation: false,
    rotationSpeed: {
      min: 0,
      max: 0,
    },
    lifetime: {
      min: 1,
      max: 3,
    },
    blendMode: "normal",
    frequency: 0.03,
    emitterLifetime: -1,
    maxParticles: 80,
    pos: {
      x: 0,
      y: 0,
    },
    addAtBack: false,
    spawnType: "circle",
    spawnCircle: {
      x: 0,
      y: 0,
      r: 0,
    },
  };

  constructor(view: FreeGameViewBehavior, model: FreeGameModelBehavior, json: any, assetManager: any) {
    super(view, model, json, assetManager);
    //updating local capsule filled data
    (ingenuity.parserModel as GameParserModel).setCurrentCapsuleFilled({ mini: 0, minor: 0, major: 0, grand: 0 });
    //update capsule filling in top jackpot bar after broken
    if ((ingenuity.parserModel as platformModel).getFreeGameBroken()) {
      this.updateCapsuleForBroken();
    }
    this.hideAutoplayButtons();
    this.hideTurboButtons();
  }

  /**
   * subscribeEvents method overrided for subscribe Jackpot Meters
   */
  protected subscribeEvents(): void {
    super.subscribeEvents();
    dispatcher.on(eventDispatchers.UPDATE_JACKPOT_METERS_VALUES, this.updateJackpotMeterValuesFG, this);
    dispatcher.on(eventDispatchers.AWARD_JACKPOT_FG, this.awardJackpotFG, this);
    dispatcher.on(eventDispatchers.FILL_JACKPOT_CAPSULE, this.updateJackpotPanelCapsule, this);
    dispatcher.on(eventDispatchers.RESET_CAPSULE_FILLED_DATA, this.resetJackpotCapsuleData, this);
    dispatcher.on(eventDispatchers.UPDATE_JACKPOT_COUNTER, this.updateCounterContinuousNow, this);
    dispatcher.on(eventDispatchers.UPDATE_CAPSULE_COUNTER_ONSTAGE_CLICK, this.updateCapsuleAndCounterOnSkip, this);
    dispatcher.on(eventDispatchers.PLAY_CAPSULE_ANIM_ON_FORCESTOP, this.playCapsuleAnimOnStageClick, this);
    dispatcher.on(eventDispatchers.HIDE_CAPSULE_ANIM_ON_FORCESTOP, this.hideCapsuleAnimOnStageClick, this);
    dispatcher.on(eventDispatchers.SHOW_JACKPOT_WINBLAST_FG, this.playBlastAnimOnWinMeter, this);
  }

  /**
   * unsubscribeEventsFG method overrided for unsubscribe Jackpot Meters
   */
  protected unsubscribeEventsFG(): void {
    super.unsubscribeEventsFG();
    dispatcher.off(eventDispatchers.UPDATE_JACKPOT_METERS_VALUES, this.updateJackpotMeterValuesFG, this);
    dispatcher.off(eventDispatchers.AWARD_JACKPOT_FG, this.awardJackpotFG, this);
    dispatcher.off(eventDispatchers.FILL_JACKPOT_CAPSULE, this.updateJackpotPanelCapsule, this);
    dispatcher.off(eventDispatchers.RESET_CAPSULE_FILLED_DATA, this.resetJackpotCapsuleData, this);
    dispatcher.off(eventDispatchers.UPDATE_JACKPOT_COUNTER, this.updateCounterContinuousNow, this);
    dispatcher.off(eventDispatchers.UPDATE_CAPSULE_COUNTER_ONSTAGE_CLICK, this.updateCapsuleAndCounterOnSkip, this);
    dispatcher.off(eventDispatchers.PLAY_CAPSULE_ANIM_ON_FORCESTOP, this.playCapsuleAnimOnStageClick, this);
    dispatcher.off(eventDispatchers.HIDE_CAPSULE_ANIM_ON_FORCESTOP, this.hideCapsuleAnimOnStageClick, this);
    dispatcher.off(eventDispatchers.SHOW_JACKPOT_WINBLAST_FG, this.playBlastAnimOnWinMeter, this);
  }

  /**
   * onShowFreeGame method overrided to update functionality of jackpot and potions
   */
  protected onShowFreeGame(): void {
    dispatcher.fireEvent(SlotEventConstantsBehavior.SHOW_BOTTOM_BAR_VIEW);
    this.showFreeSpinScreen();
    this.reelBGSpine.setPause(false);
    this.reelBGSpine.playAnim("freegame_reel", true);
    dispatcher.fireEvent(SlotEventConstantsBehavior.CHANGE_BACKGROUND, SlotConstantsBehavior.FREEGAME_BG_SHOW);
    (ingenuity.soundManager as any).stop(SoundConstant.BASEGAME_BGM_INTRO, "soundList");
    (ingenuity.soundManager as any).stop(SoundConstant.BASEGAME_BGMLOOP, "soundList");
    (ingenuity.soundManager as any).stop(SoundConstant.FREE_GAME_INTRO, "soundList_1");
    (ingenuity.soundManager as any).playSound(SoundConstant.FREGAME_BGLOOP, 1, true, "soundList_1");
    this.showFreegameWithAlphaTween();
    dispatcher.fireEvent(SlotEventConstantsBehavior.INITIALIZE_TOP_LOGO_FG);
    ingenuity.deviceEnv.getOrientation() === constants.ORIENTATION.PORTRAIT && this.view.onShowPortraitButtonpanel();
    this.view.getContainerByID("portraitButtonsContainer") &&
      (this.view.getContainerByID("portraitButtonsContainer").visible = true);
    this.UpdateFreeSpinCounterText();
    this.hideAutoplayButtons();
    this.hideTurboButtons();
    this.hideForceStopButton();
    this.stopSoundOnFreeGameStart();
    if ((ingenuity.configData.turboEnabled) && (ingenuity.configData.turboEnabled === true)) {
      this.activateTurboMode();
    }
    else {
      SlotConstantsBehavior.SHOW_TURBO_BUTTONS && this.deactivateTurboMode();
    }
    dispatcher.fireEvent(eventDispatchers.UPDATE_JACKPOT_METERS_VALUES);
    if ((ingenuity.parserModel as GameParserModel).getIsMagicPotionBG()) {
      dispatcher.fireEvent(eventDispatchers.HIDE_MAGIC_POTION);
    }

    //  this.playFreegameIdleSpine();
    dispatcher.fireEvent(SlotEventConstantsBehavior.HIDE_TOP_GAME_LOGO);
  }

  //Overrided to remove player message initialization
  protected onInitializeAllControllers(evt: IEvent): void {
    this.initializeButtonController();
    this.initializeMeterController();
    this.initializePlayerMsgController();
    this.initializeReelPanelController();
    this.initializeWinPresentationController();
  }

  /**
   * initializeComponent method overrided for initialize Jackpot Meters
   */
  protected initializeComponents(): void {
    super.initializeComponents();
    this.reelBGSpine = this.view.getSpineById("reel") as SpineBase;
    // this.freegameBgSpineContainer = this.view.getContainerByID("freegameBgSpineContainer");
    this.grandJackpotMeter = this.view.getMeterById("grandJackpotMeter") as MeterBitmap;
    this.majorJackpotMeter = this.view.getMeterById("majorJackpotMeter") as MeterBitmap;
    this.minorJackpotMeter = this.view.getMeterById("minorJackpotMeter") as MeterBitmap;
    this.miniJackpotMeter = this.view.getMeterById("miniJackpotMeter") as MeterBitmap;
    this.jackpotPanelContainer = this.view.getContainerByID("jackpotPanelContainer");
    this.jackpotPanelGrandContainer = this.view.getContainerByID("jackpotPanelGrandContainer");
    this.jackpotPanelMajorContainer = this.view.getContainerByID("jackpotPanelMajorContainer");
    this.jackpotPanelMinorContainer = this.view.getContainerByID("jackpotPanelMinorContainer");
    this.jackpotPanelMiniContainer = this.view.getContainerByID("jackpotPanelMiniContainer");
    this.particleContainer = this.view.getContainerByID("particle_container");
    this.miniJackpotnumber = this.view.getMeterById("miniJackpotnumber") as MeterBitmap;
    this.minorJackpotNumber = this.view.getMeterById("minorJackpotNumber") as MeterBitmap;
    this.majorJackpotNumber = this.view.getMeterById("majorJackpotNumber") as MeterBitmap;
    this.grandJackpotNumber = this.view.getMeterById("grandJackpotNumber") as MeterBitmap;
    this.counterEffectContainer = this.view.getContainerByID("counter_effect_container");
    this.jackpotAlpha = this.view.getShapeById("jackpotAlpha");
  }

  // /**
  //   * playFreegameIdleSpine method play freegame idle reel spine
  //   */
  // private playFreegameIdleSpine(): void {
  //   this.freegameBgSpineContainer.visible = true
  //   this.freegameBgSpine && (this.freegameBgSpine.visible = true);
  //   this.freegameBgSpine.playAnim(SlotConstantsBehavior.FREEGAME_IDLE_SPINE, true);
  //   this.freegameBgSpine.playAnim("freegame_idle_reel_effect", true);
  //   this.freegameBgSpine && this.freegameBgSpine.setPause(false);
  // }

  /**
   * updateJackpotMeterValues method set Jackpot Meters Values
   */
  private updateJackpotMeterValuesFG(): void {
    let currentBet: number = ingenuity.parserModel.getCurrentTotalBet();
    const grandJackpot =
      currentBet *
      (ingenuity.parserModel as GameParserModel).getJackpotMultipliers()[ingenuity.configData.jackpot_grand];
    const majorJackpot =
      currentBet *
      (ingenuity.parserModel as GameParserModel).getJackpotMultipliers()[ingenuity.configData.jackpot_major];
    const minorJackpot =
      currentBet *
      (ingenuity.parserModel as GameParserModel).getJackpotMultipliers()[ingenuity.configData.jackpot_minor];
    const miniJackpot =
      currentBet *
      (ingenuity.parserModel as GameParserModel).getJackpotMultipliers()[ingenuity.configData.jackpot_mini];

    this.grandJackpotMeter.setCurrencyFormattedValue(grandJackpot.toString());
    this.majorJackpotMeter.setCurrencyFormattedValue(majorJackpot.toString());
    this.minorJackpotMeter.setCurrencyFormattedValue(minorJackpot.toString());
    this.miniJackpotMeter.setCurrencyFormattedValue(miniJackpot.toString());
  }

  /**
   * Method playAnticipationSound to play updated sound
   */
  public playAnticipationSound() {
    if (!ingenuity.configData.isPlayAnticipationSound) {
      ingenuity.configData.isPlayAnticipationSound = true;
      (ingenuity.soundManager as any).play(
        SoundConstantGame.ANTICIPATION_SOUND,
        1,
        true,
        gameConstants.SOUND_LIST_PRELOAD
      );
    }
  }

  //overrided to reset saved data call
  protected resetFreeGame(): void {
    (ingenuity.parserModel as GameParserModel).setCurrentFreeSpinCount(0);
    (ingenuity.parserModel as GameParserModel).setFreeSpinNum(0);
    (ingenuity.parserModel as GameParserModel).setFreeSpinWinAmt(0);
    dispatcher.fireEvent(SlotEventConstantsBehavior.SET_WIN_VALUE_TO_DEFAULT);
    dispatcher.fireEvent(SlotEventConstants.FG_DISABLED_ALL_BUTTONS);
    dispatcher.fireEvent(SlotEventConstantsBehavior.CHANGE_BACKGROUND, SlotConstantsBehavior.BASEGAME_BG_SHOW);
    dispatcher.fireEvent(SlotEventConstantsBehavior.SUBSCRIBE_BASEVIEW_EVENTS);
    this.playerMsgController.unSubscribeFreeGameEvents();
  }

  /**
   * method stopSoundOnFreeGameStart to stop the sound before free game start
   */
  private stopSoundOnFreeGameStart(): void {
    (ingenuity.soundManager as any).stop(SoundConstant.FREE_GAME_INTRO, gameConstants.SOUND_LIST_POSTLOAD);
  }

  /**
   * Override to update bottom bar win in broken
   */
  protected checkBrokenGame(): void {
    if ((ingenuity.parserModel as GameParserModel).getFreeGameBroken()) {
      dispatcher.fireEvent(SlotEventConstantsBehavior.UPDATE_FREESPIN_LABEL_COUNT);
      delayedCall(
        "showFreeGameDelay",
        500,
        function () {
          killDelayedCall("showFreeGameDelay");
          dispatcher.fireEvent(SlotEventConstants.FG_RESET_METERS);
          dispatcher.fireEvent(SlotEventConstants.SUBSCRIBE_EVENTS_ON_REEL_START);
          dispatcher.fireEvent(SlotEventConstantsBehavior.SHOW_BROKEN_GAME_FG);
          dispatcher.fireEvent(SlotEventConstants.HIDE_BASEGAME_VIEW);
          (ingenuity.parserModel as GameParserModel).setFreeGameBroken(false);
        },
        this
      );

      //Update bottom bar win in case of win basegame inside freegame
      if ((ingenuity.parserModel as platformModel).getFreeGameBroken()) {
        const jackpotAmountBg: number =
          (ingenuity.parserModel as GameParserModel).getGrandJackpotWonBG() +
          (ingenuity.parserModel as GameParserModel).getMajorJackpotWonBG() +
          (ingenuity.parserModel as GameParserModel).getMinorJackpotWonBG() +
          (ingenuity.parserModel as GameParserModel).getMiniJackpotWonBG();
        const potsAmountBg: number = (ingenuity.parserModel as GameParserModel).getPrizePotCredit();
        const LineWinAmount: number = (ingenuity.parserModel as GameParserModel).getWinLineAmount();
        (ingenuity.parserModel as GameParserModel).setBaseGameWinAmt(jackpotAmountBg + potsAmountBg + LineWinAmount);
        if ((ingenuity.parserModel as GameParserModel).getBaseGameWinAmt()) {
          dispatcher.fireEvent(SlotEventConstantsBehavior.UPDATE_BOTTOM_BAR_WIN, {
            value: (ingenuity.parserModel as GameParserModel).getBaseGameWinAmt(),
          });
        }
      }
    }
  }

  /**
   * This method is use to find currently landed jackpot counts on reelgrid
   */
  private updateCapsuleForBroken(): void {
    let currentlyLandedPots: IObject = (ingenuity.parserModel as GameParserModel).getPotionJackpotPositionsFG();
    let currentLandedJackpotCounts: IObject = {};

    if (Object.keys(currentlyLandedPots).length === 0) {
      //This code will execute when no pots have landed on broken reelgrid
      this.updateCapsuleAndCounter((ingenuity.parserModel as GameParserModel).getTotalCapsuleCount());
    } else {
      //This code will execute when any pots have landed on reelgrid during broken
      currentlyLandedPots.forEach((obj: IObject) => {
        let value = Object.values(obj)[0];
        if (currentLandedJackpotCounts.hasOwnProperty(value)) {
          currentLandedJackpotCounts[value]++;
        } else {
          currentLandedJackpotCounts[value] = 1;
        }
      });
    }
    //now calculate the difference in total jackpots and currently landed jackpots
    this.calculateFinalCapsuleCount(currentLandedJackpotCounts);
  }

  /**
   * This method is use to find the difference in Total and current landed jackpots and create data in below form
   * { mini: 0, minor: 0, major: 0, grand: 0 }
   */
  private calculateFinalCapsuleCount(currentLandedJackpot: IObject): void {
    //Total Jackpots Occured
    let totalJackpotCount: IObject = (ingenuity.parserModel as GameParserModel).getTotalCapsuleCount();

    //Note: Below is the code to remove "jackpot_" from the total jackpots object as we need only jackpot name in output
    // Extract keys from the first object and initialize their values to 0
    const outputObject = Object.keys(totalJackpotCount).reduce((acc: IObject, key: string) => {
      const newKey = key.replace("jackpot_", "");
      acc[newKey] = totalJackpotCount[key];
      return acc;
    }, {});
    // Updating the difference in output object between both total and current landed jackpots
    Object.keys(currentLandedJackpot).forEach((key) => {
      const matchingKey = Object.keys(outputObject).find((outputKey) => outputKey.includes(key));
      if (matchingKey) {
        outputObject[matchingKey] -= currentLandedJackpot[key];
      }
    });
    //Now update capsule & counter in top bar
    this.updateCapsuleAndCounter(outputObject);
  }

  /**
   * This method is use to update both capsule & counter in broken game
   */
  private updateCapsuleAndCounter(outputObject: IObject): void {
    //below is the code to send data in this form {"mini": 0}, {"mini": 1} one by one
    for (const key in outputObject) {
      if (outputObject.hasOwnProperty(key)) {
        const value = outputObject[key];
        for (let i = 0; i < value; i++) {
          const partialObj: IObject = {};
          partialObj[key] = i;
          this.updateJackpotPanelCapsule(partialObj);
          this.updateJackpotCounterBroken(key, i);
        }
      }
    }
  }

  /**
   * This method is use to update the jackpot counter in case of broken
   */
  private updateJackpotCounterBroken(jackpotName: string, count: number): void {
    if (jackpotName === "mini") {
      if (count >= 2) {
        this.miniJackpotCounter += 1;
        this.miniJackpotnumber.setValue(this.miniJackpotCounter);
      }
    } else if (jackpotName === "minor") {
      if (count >= 2) {
        this.minorJackpotCounter += 1;
        this.minorJackpotNumber.setValue(this.minorJackpotCounter);
      }
    } else if (jackpotName === "major") {
      if (count >= 2) {
        this.majorJackpotCounter += 1;
        this.majorJackpotNumber.setValue(this.majorJackpotCounter);
      }
    } else if (jackpotName === "grand") {
      if (count >= 2) {
        this.grandJackpotCounter += 1;
        this.grandJackpotNumber.setValue(this.grandJackpotCounter);
      }
    }
  }

  /**
   * updateJackpotPanelCapsule method update jackpot panel capsules and counter functionality
   * { "grand": 1 } "grand" is jp type and 1 is capsule stage from [0,1,2]
   */
  private updateJackpotPanelCapsule(evt?: IObject): any {
    // Initialise with "evt.data" when method called from event, else use "evt" in case of broken
    const entries: any[] = evt.data ? Object.entries(evt.data) : Object.entries(evt);
    const jackpotWons: string[] = ["mini", "minor", "major", "grand"];
    for (let [jackpotType, JackpotIndex] of entries) {
      if (JackpotIndex < 3 && jackpotWons.includes(jackpotType)) {
        this.updateCapsule(jackpotType, JackpotIndex);
        (ingenuity.soundManager as any).playSound(`jackpot_progress_`+jackpotType, 1, false, "soundList_1");

      }
    }
  }

  /**
   * updateCapsule method update jackpot panel capsules data
   */
  private updateCapsule(jackpotType: string, JackpotIndex: number): void {
    this.showCapsule(this.capitalizeFirstLetter(jackpotType), JackpotIndex);

    if (JackpotIndex === 1) {
      this.showDataOnCapsule(jackpotType, this.getCapsuleDataIndex(jackpotType));
    } else if (JackpotIndex === 2) {
      this.hideDataOnCapsule(jackpotType, this.getCapsuleParticle(jackpotType));
    }

    this.updateCapsuleCount(jackpotType);
  }

  /**
   * getCapsuleDataIndex method returns value to show presentation on capsules
   */
  private getCapsuleDataIndex(jackpotType: string): number {
    switch (jackpotType) {
      case "mini":
        return 3;
      case "minor":
        return 2;
      case "major":
        return 1;
      case "grand":
        return 0;
      default:
        return -1;
    }
  }

  /**
   * getCapsuleParticle method returns particle as per jp
   */
  private getCapsuleParticle(jackpotType: string): any {
    switch (jackpotType) {
      case "mini":
        return this.particle_mini;
      case "minor":
        return this.particle_minor;
      case "major":
        return this.particle_major;
      case "grand":
        return this.particle_grand;
      default:
        return null;
    }
  }

  /**
   * Method showDataOnCapsule to show data
   */
  private showDataOnCapsule(jackpotType: string, jackpotNumber: number): void {
    this.view.getImageById(`${jackpotType}_frame_back_glow`).visible = true;
    this.view.getImageById(`${jackpotType}_capsule_frame`).visible = true;
    this.playParticleAnim(jackpotNumber, jackpotType);
  }

  /**
   * Method hideDataOnCapsule to hide data
   */
  private hideDataOnCapsule(jackpotType: string, partical: number): void {
    this.view.getImageById(`${jackpotType}_frame_back_glow`).visible = false;
    this.view.getImageById(`${jackpotType}_capsule_frame`).visible = false;

    this.stopParticleAnim(partical);
    this.updateJackpotCounter(jackpotType);
  }

  /**
   * This method is use to hide capsule shine and particle animation
   */
  private playCapsuleAnimOnStageClick(evt?: IEvent): void {
    if (!this.view.getImageById(`${evt.data.data}_frame_back_glow`).visible) {
      let particleNumber: number = this.findParticleNumber(evt.data.data);
      this.view.getImageById(`${evt.data.data}_frame_back_glow`).visible = true;
      this.view.getImageById(`${evt.data.data}_capsule_frame`).visible = true;
      this.playParticleAnim(particleNumber, evt.data.data);
    }
  }

  /**
   * This method is use to hide capsule shine and particle animation
   */
  private hideCapsuleAnimOnStageClick(evt?: IEvent): void {
    if (this.view.getImageById(`${evt.data.data}_frame_back_glow`).visible) {
      let particleNumber: number = this.findParticleNumber(evt.data.data);
      this.view.getImageById(`${evt.data.data}_frame_back_glow`).visible = false;
      this.view.getImageById(`${evt.data.data}_capsule_frame`).visible = false;
      this.stopParticleAnim(particleNumber);
    }
  }

  /**
   * Method findParticleNumber find jackpot particle anim
   */
  private findParticleNumber(jackpotName: string): number {
    if (jackpotName === "grand") {
      return 0;
    } else if (jackpotName === "major") {
      return 1;
    } else if (jackpotName === "minor") {
      return 2;
    } else if (jackpotName === "mini") {
      return 3;
    }
  }

  // jackpot: get it as child from container
  private playParticleAnim(jackpot: number, jackpotType: string): void {
    this.particleContainer.visible = true;
    this.particleContainer.children[jackpot].visible = true;
    this.particleContainer.children[jackpot].playAnim(`${jackpotType}_particles`, true);
  }

  /**
   * Method stopParticleAnim stop particle animation
   */
  private stopParticleAnim(jackpot: number): void {
    this.particleContainer.children[jackpot].visible = false;
  }

  /**
   * This method is use to update jackpot counter each time after 3 capsules are collected
   */
  private updateCounterContinuousNow(evt?: IObject): void {
    this.updateJackpotCounter(evt.data);
  }

  //update jackpot counter value
  private updateJackpotCounter(jackpotType: string): void {
    if (!(ingenuity.parserModel as platformModel).getFreeGameBroken()) {
      if (jackpotType === "mini") {
        this.miniJackpotCounter++;
        this.miniJackpotnumber.setValue(this.miniJackpotCounter);
        (ingenuity.soundManager as any).playSound(
          SoundConstantGame.JACKPOT_COUNTER_MINI,
          1,
          false,
          gameConstants.SOUND_LIST_POSTLOAD
        );
        this.playCounterEffect(3);
      } else if (jackpotType === "minor") {
        this.minorJackpotCounter++;
        this.minorJackpotNumber.setValue(this.minorJackpotCounter);
        (ingenuity.soundManager as any).playSound(
          SoundConstantGame.JACKPOT_COUNTER_MINOR,
          1,
          false,
          gameConstants.SOUND_LIST_POSTLOAD
        );
        this.playCounterEffect(2);
      } else if (jackpotType === "major") {
        this.majorJackpotCounter++;
        this.majorJackpotNumber.setValue(this.majorJackpotCounter);
        (ingenuity.soundManager as any).playSound(
          SoundConstantGame.JACKPOT_COUNTER_MAJOR,
          1,
          false,
          gameConstants.SOUND_LIST_POSTLOAD
        );
        this.playCounterEffect(1);
      } else if (jackpotType === "grand") {
        this.grandJackpotCounter++;
        this.grandJackpotNumber.setValue(this.grandJackpotCounter);
        (ingenuity.soundManager as any).playSound(
          SoundConstantGame.JACKPOT_COUNTER_GRAND,
          1,
          false,
          gameConstants.SOUND_LIST_POSTLOAD
        );
        this.playCounterEffect(0);
      }
    }
  }

  //play animation when jackpot counter increases
  private playCounterEffect(jackpotType: number): void {
    this.counterEffectContainer.visible = true;
    let counterEffectChild: IObject = this.counterEffectContainer.children[jackpotType];
    counterEffectChild.visible = true;
    counterEffectChild.playAnim("animation", false);
  }

  /**
   * Method awardJackpotFG check for awards jackpots during FG
   */
  private awardJackpotFG(): void {
    dispatcher.fireEvent(SlotEventConstantsBehavior.HIDE_FREE_GAME_WIN_METER);
    const startIndex: number = 0;
    const awardJackpot: IObject = (ingenuity.parserModel as GameParserModel).getAwardJackpotsFG();
    if (awardJackpot) {
      this.jackpotAlpha.visible = true;
      this.jackpotAlpha.alpha = 0;
      const jackpot: [string, number][] = Object.entries(awardJackpot);
      this.sortedJackpot = this.sequenceJackpot(jackpot);
      this.checkForJackpot(startIndex, this.sortedJackpot);
    }
  }

  /**
   * Method checkForJackpot check jackpots won
   */
  private checkForJackpot(index: number, sortedJackpot: [string, number][]): void {
    if (index >= sortedJackpot.length) {
      this.jackpotAlpha.visible = false;
      dispatcher.fireEvent(SlotEventConstants.FG_SHOW_NEXT_WIN_PRESENTATION);
    } else {
      if (sortedJackpot[index][0] === "jackpot_mini") {
        this.jackpotMini(index);
      } else if (sortedJackpot[index][0] === "jackpot_minor") {
        this.jackpotMinor(index);
      } else if (sortedJackpot[index][0] === "jackpot_major") {
        this.jackpotMajor(index);
      } else if (sortedJackpot[index][0] === "jackpot_grand") {
        this.jackpotGrand(index);
      }
    }
  }

  /**
   * Method sequenceJackpot sets jackpots wons array in sequence
   */
  private sequenceJackpot(jackpot: IObject): any {
    const searchKey: string[] = ["jackpot_mini", "jackpot_minor", "jackpot_major", "jackpot_grand"];
    let updatedArray: [string, number][] = [];
    for (let j = 0; j < searchKey.length; j++) {
      for (let i = 0; i < jackpot.length; i++) {
        if (searchKey[j] === jackpot[i][0] && jackpot[i][1] >= 1) {
          //push jackpot whose corresponding multiplier is greater than 1
          updatedArray.push(jackpot[i]);
          break; // Exit the loop since the JP key is found
        }
      }
    }
    return updatedArray;
  }

  /**
   * Method override to update alpha
   */
  protected showFreegameWithAlphaTween() {
    this.view.visible = true;
    this.view.alpha = 0.8;
    const freeGameFadeIn = ingenuity.currentGame.add
      .tween(this.view)
      .to({ alpha: 1 }, SlotConstantsBehavior.FREE_GAME_FADE_IN_TIME, undefined, true);
    freeGameFadeIn.onComplete.add(() => {
      this.view.getContainerByID("topPortraitButtonsContainer") &&
        (this.view.getContainerByID("topPortraitButtonsContainer").visible = true);
      ingenuity.currentGame.tweens.remove(freeGameFadeIn);
      freeGameFadeIn.stop();
    }, this);
  }

  /**
   * Method jackpotGrand update grand jackpot functionality on top panel
   */
  private jackpotGrand(index: number): void {
    this.view.addChild(this.jackpotPanelGrandContainer);
    this.jackpotPanelGrandContainer.children[0].visible = true;
    this.jackpotPanelGrandContainer.children[0].playAnim("animation", true);
    this.playTween(this.jackpotPanelGrandContainer, index, 0);
    this.playTrailAnimation("grand");
  }

  /**
   * Method jackpotMajor update major jackpot functionality on top panel
   */
  private jackpotMajor(index: number): void {
    this.view.addChild(this.jackpotPanelMajorContainer);
    this.jackpotPanelMajorContainer.children[0].visible = true;
    this.jackpotPanelMajorContainer.children[0].playAnim("animation", true);
    this.playTween(this.jackpotPanelMajorContainer, index, 1);
    this.playTrailAnimation("major");
  }

  /**
   * Method jackpotMajor update minor jackpot functionality on top panel
   */
  private jackpotMinor(index: number): void {
    this.view.addChild(this.jackpotPanelMinorContainer);
    this.jackpotPanelMinorContainer.children[0].visible = true;
    this.jackpotPanelMinorContainer.children[0].playAnim("animation", true);
    this.playTween(this.jackpotPanelMinorContainer, index, 2);
    this.playTrailAnimation("minor");
  }

  /**
   * Method jackpotMini update mini jackpot functionality on top panel
   */
  private jackpotMini(index: number): void {
    this.view.addChild(this.jackpotPanelMiniContainer);
    this.jackpotPanelMiniContainer.children[0].visible = true;
    this.jackpotPanelMiniContainer.children[0].playAnim("animation", true);
    this.playTween(this.jackpotPanelMiniContainer, index, 3);
    this.playTrailAnimation("mini");
  }

  /**
   * Method playTween play tween for jackpot containers at last spin
   */
  private playTween(jackpotContainer: Container, index: number, layering: number): void {
    (ingenuity.soundManager as any).playSound(
      SoundConstantGame.JACKPOT_FS_WIN,
      1,
      false,
      gameConstants.SOUND_LIST_POSTLOAD
    );

    const zoomOutTween: ITween = ingenuity.currentGame.add
      .tween(jackpotContainer.scale)
      .to({ x: 1.05, y: 1.05 }, 400, Linear.None, true);
    const fadeInTween: ITween = ingenuity.currentGame.add
      .tween(this.jackpotAlpha)
      .to({ alpha: 1 }, 400, Linear.None, true);
    fadeInTween.onComplete.addOnce(() => {
      fadeInTween.stop();
      ingenuity.currentGame.tweens.remove(fadeInTween);
      zoomOutTween.stop();
      ingenuity.currentGame.tweens.remove(zoomOutTween);
      delayedCall(
        "tweenDelay",
        500,
        () => {
          killDelayedCall("tweenDelay");
          const zoomInTween: ITween = ingenuity.currentGame.add
            .tween(jackpotContainer.scale)
            .to({ x: 1, y: 1 }, 400, Linear.None, true);
          const fadeOutTween: ITween = ingenuity.currentGame.add
            .tween(this.jackpotAlpha)
            .to({ alpha: 0 }, 400, Linear.None, true);
          fadeOutTween.onComplete.addOnce(() => {
            fadeOutTween.stop();
            ingenuity.currentGame.tweens.remove(fadeOutTween);
            zoomInTween.stop();
            ingenuity.currentGame.tweens.remove(zoomInTween);
            jackpotContainer.children[0].visible = false;
            this.jackpotPanelContainer.addChildAt(jackpotContainer, layering);
            this.checkForJackpot(index + 1, this.sortedJackpot);
          }, this);
        },
        this
      );
    }, this);
  }

  /**
   * Method playTrailAnimation play trail from jackpot top containers to bottom at win meter
   */
  protected playTrailAnimation(currentJackpot: string): void {
    this.smoke = this.view.getImageById(currentJackpot + "Particle");
    // this.particleData.animConfig[0].image = "particle_" + currentJackpot;
    this.createTrailImage(currentJackpot);
    this.createTrailEmitter(currentJackpot);
    this.playMultiplierTrailAnim(currentJackpot);
  }

  /**
   * This method is use to create trail image
   */
  private createTrailImage(currentJackpot: string): void {
    this.smokeSprite = new BitmapImage(ingenuity.currentGame, 0, 0, "smoke_puff");
    this.smokeSprite.x = this.view.json.smokeSpriteXY[currentJackpot].x;
    this.smokeSprite.y = this.view.json.smokeSpriteXY[currentJackpot].y;
    this.particleData.id = this.view.json.smokeSprite.id;
    this.smokeSprite.name = this.view.json.smokeSprite.name;
    this.smokeSprite.alpha = this.view.json.smokeSprite.alpha;
    this.smokeSprite.scale.set(this.view.json.smokeSprite.scale);
    this.smokeSprite.anchor.set(this.view.json.smokeSprite.anchorX, this.view.json.smokeSprite.anchorY);
    this.smoke.parent.addChild(this.smokeSprite);
  }

  /**
   * This method create emitter for trail
   */
  private createTrailEmitter(currentJackpot: string): void {
    const particle: Emitter = ingenuity.currentGame.add.emitter(
      this.view.getContainerByID(currentJackpot + "TrailAnimationContainer"),
      this.particleData,
      this.particleConfig
    ) as Emitter;
    particle.autoUpdate = true;
    particle.emit = true;
    particle.updateOwnerPos(this.smokeSprite.x, this.smokeSprite.y);
  }

  /**
   * This method is use to play the trail tween
   */
  private playMultiplierTrailAnim(currentJackpot: string): void {
    let trailTween: ITween;
    let trailConfigs: IObject = this.view.json.smokeSprite;
    let points: number[][] = this.addSineWave(
      this.smokeSprite.x,
      this.smokeSprite.y,
      trailConfigs.finalX,
      trailConfigs.finalY,
      trailConfigs.amplitude,
      trailConfigs.frequency,
      trailConfigs.numPoints
    );
    trailTween = ingenuity.currentGame.add
      .tween(this.smokeSprite)
      .to({ x: points[0], y: points[1] }, 800, undefined, true);
    trailTween.onComplete.addOnce(() => {
      let em: Emitter;
      em = ingenuity.currentGame.particles.getEmitterById(trailTween.target.name);
      em.autoUpdate = false;
      em.emit = false;
      em.destroy();

      trailTween.stop();
      trailTween.onUpdateCallback = null;
      ingenuity.currentGame.tweens.remove(trailTween);
      trailTween.target.parent.removeChild(trailTween.target);

      //Update jackpot awarded amount in win meter after trail complete
      let jackpotAmount: number = this.getTotalJackpotPrize(currentJackpot);
      dispatcher.fireEvent(eventDispatchers.UPDATE_JACKPOT_WIN_PRIZE, jackpotAmount);

      //Play Blasted Bubbles
      this.playBlastAnimOnWinMeter();
    }, this);

    trailTween.onUpdateCallback((evt: IObject) => {
      let em: Emitter;
      em = ingenuity.currentGame.particles.getEmitterById(evt.target.name);
      em.updateOwnerPos(evt.target.x, evt.target.y);
    });
  }

  /**
   * This method will return a 2D array of [x,y] coordinates to create wave pattern in trail tween
   */
  private addSineWave(
    startX: number,
    startY: number,
    endX: number,
    endY: number,
    amplitude: number,
    frequency: number,
    numPoints: number
  ): number[][] {
    // Calculate the change in X and Y per point
    const deltaX: number = (endX - startX) / (numPoints - 1);
    const deltaY: number = (endY - startY) / (numPoints - 1);

    // Arrays to store X and Y coordinates
    const xCoords: number[] = [];
    const yCoords: number[] = [];

    // Generate points along the line and add sine wave to Y coordinates
    for (let i = 0; i < numPoints; i++) {
      // Calculate current X coordinate
      const x: number = startX + i * deltaX;
      // Calculate Y coordinate with added sine wave
      const y: number =
        startY + i * deltaY + amplitude * Math.sin((2 * Math.PI * frequency * (x - startX)) / (endX - startX));
      // Store X and Y coordinates
      xCoords.push(x);
      yCoords.push(y);
    }

    // Return X and Y coordinates as separate arrays
    return [xCoords, yCoords];
  }

  /**
   * Method resetJackpotCapsuleData resets top jackpot capsules data
   */
  private resetJackpotCapsuleData(): void {
    (ingenuity.parserModel as GameParserModel).setCurrentCapsuleFilled({});
  }

  

  /**
   * This method is use to get total jackpot awarded prize
   */
  private getTotalJackpotPrize(currentJackpot: string): number {
    let jackpotPrize: number = 0;
    if (currentJackpot === "grand") {
      jackpotPrize = (ingenuity.parserModel as GameParserModel).getGrandJackpotPrizeFG();
    } else if (currentJackpot === "major") {
      jackpotPrize = (ingenuity.parserModel as GameParserModel).getMajorJackpotPrizeFG();
    } else if (currentJackpot === "minor") {
      jackpotPrize = (ingenuity.parserModel as GameParserModel).getMinorJackpotPrizeFG();
    } else if (currentJackpot === "mini") {
      jackpotPrize = (ingenuity.parserModel as GameParserModel).getMiniJackpotPrizeFG();
    }
    return jackpotPrize;
  }

  /**
   * Method updateCapsuleAndCounterOnSkip update top jackpot panel data on stage click
   */
  private updateCapsuleAndCounterOnSkip(): void {
    this.convertObjectKeys((ingenuity.parserModel as GameParserModel).getTotalCapsuleCount());
  }

  /**
   * Method convertObjectKeys rename the object keys
   */
  private convertObjectKeys(currentJackpots: IObject): void {
    const outputObject = Object.keys(currentJackpots).reduce((acc: IObject, key: string) => {
      const newKey = key.replace("jackpot_", "");
      acc[newKey] = currentJackpots[key];
      return acc;
    }, {});
    this.updateCapsuleCounterNow(outputObject);
  }

  /**
   * Method updateCapsuleCounterNow updates counter of top jackpot panel
   */
  private updateCapsuleCounterNow(outputObject: IObject): void {
    this.resetCountersOnSkipPresentation();

    //below is the code to send data in this form {"mini": 0}, {"mini": 1} one by one
    for (const key in outputObject) {
      if (outputObject.hasOwnProperty(key)) {
        const value = outputObject[key];
        for (let i = 0; i < value; i++) {
          const partialObj: IObject = {};
          partialObj[key] = i;
          this.fillCapsuleNow(partialObj);
        }
      }
    }
  }

  /**
   * Method capitalizeFirstLetter do uppercase of firstletter
   */
  private capitalizeFirstLetter(str: string): string {
    if (!str) return str; // Return the original string if it's empty or null
    return `${str.charAt(0).toUpperCase()}${str.slice(1)}`;
  }

  /**
   * Method fillCapsuleNow fills jackpot capsule data
   */
  private fillCapsuleNow(evt?: IObject): void {
    const jackpotWons: string[] = ["mini", "minor", "major", "grand"];
    const entries: any[] = Object.entries(evt);
    for (let [jackpotType, JackpotIndex] of entries) {
      if (jackpotWons.includes(jackpotType)) {
        if (JackpotIndex < 3) {
          this.updateCapsuleOnStageClick(jackpotType, JackpotIndex);
        } else {
          this.incrementJackpotCounter(jackpotType);
        }
      }
    }
  }

  /**
   * This method is use to update capsules on stage click
   */
  private updateCapsuleOnStageClick(jackpotType: string, JackpotIndex: number): void {
    this.showCapsule(this.capitalizeFirstLetter(jackpotType), JackpotIndex);
    if (JackpotIndex === 2) {
      this.incrementJackpotCounter(jackpotType);
    }
    this.updateCapsuleCount(jackpotType);
  }

  /**
   * This method shows JP container
   */
  private showCapsule(jackpotType: string, JackpotIndex: number): void {
    
    this.view.getContainerByID(`jackpotPanelFill${jackpotType}Container`).children[3 + JackpotIndex].visible = true;
    
  }

  /**
   * This method update jackpot counter value
   */
  private incrementJackpotCounter(jackpotType: string): void {
    switch (jackpotType) {
      case "mini":
        this.miniJackpotCounter += 1;
        this.miniJackpotnumber.setValue(this.miniJackpotCounter);
        break;
      case "minor":
        this.minorJackpotCounter += 1;
        this.minorJackpotNumber.setValue(this.minorJackpotCounter);
        break;
      case "major":
        this.majorJackpotCounter += 1;
        this.majorJackpotNumber.setValue(this.majorJackpotCounter);
        break;
      case "grand":
        this.grandJackpotCounter += 1;
        this.grandJackpotNumber.setValue(this.grandJackpotCounter);
        break;
    }
  }

  /**
   * This method update capsule count
   */
  private updateCapsuleCount(jackpotType: string): void {
    const parserModel = ingenuity.parserModel as GameParserModel;
    parserModel.getCurrentCapsuleFilled()[jackpotType] += 1;
    parserModel.setCurrentCapsuleFilled(parserModel.getCurrentCapsuleFilled());
  }

  /**
   * Method resetCountersOnSkipPresentation reset top panel jackpot values
   */
  private resetCountersOnSkipPresentation(): void {
    this.miniJackpotCounter = 0;
    this.minorJackpotCounter = 0;
    this.majorJackpotCounter = 0;
    this.grandJackpotCounter = 0;
    (ingenuity.parserModel as GameParserModel).setCurrentCapsuleFilled({ mini: 0, minor: 0, major: 0, grand: 0 });
  }

  private playBlastAnimOnWinMeter(): void {
    const winHit = this.view.getContainerByID("freeGameJackpotWinHitCont").children[0];
    winHit.visible = true;
    winHit.playAnim("trail_hit_effect", false);
  }
}
